import { React } from "react";
import { NavLink } from "react-router-dom";

const DashboardLink = (props) => {
  return (
    <NavLink
      to={props.to}
      activeClassName="dashboard-active"
      exact={true}
      className={
        props.linkName === "Sign Out"
          ? "dashboard-link sign-out-link"
          : "dashboard-link"
      }
      onClick={props.handleSideBarLinkClick}
    >
      {props.icon}
      {props.linkName}
    </NavLink>
  );
};

export default DashboardLink;
